import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import api from '../../services/api/api';
import { isGlobalAdminUser } from '../../utils/access';

const isResumeMarketingDepartmentName = (deptName) => {
  const name = String(deptName || '')
    .trim()
    .toLowerCase();
  if (!name) return false;
  if (name === 'resume marketing') return true;
  return name.includes('resume') && name.includes('marketing');
};

/**
 * Resume Tracking: TL (RM dept), assigned Employee (RM dept), or global Admin.
 */
const ResumeMarketingResumeTrackingRoute = ({ children, requireCreate = false }) => {
  const { user } = useSelector((state) => state.auth);
  const [resolved, setResolved] = useState(null);

  useEffect(() => {
    let cancelled = false;

    const run = async () => {
      if (isGlobalAdminUser(user)) {
        if (!cancelled) setResolved(true);
        return;
      }

      const roleName = String(user?.role?.name || '').trim();
      if (!user || (roleName !== 'TL' && roleName !== 'Employee')) {
        if (!cancelled) setResolved(false);
        return;
      }

      if (requireCreate && roleName !== 'TL' && !isGlobalAdminUser(user)) {
        if (!cancelled) setResolved(false);
        return;
      }

      let deptName = user?.employee?.department?.name;
      if (!deptName) {
        try {
          const res = await api.get('/employee/profile');
          deptName = res?.data?.data?.department?.name;
        } catch {
          deptName = '';
        }
      }

      const inDept = isResumeMarketingDepartmentName(deptName);
      if (!cancelled) setResolved(inDept);
    };

    run();
    return () => {
      cancelled = true;
    };
  }, [user, requireCreate]);

  if (resolved === null) {
    return (
      <div className="flex min-h-[40vh] items-center justify-center text-sm text-content-muted">
        Checking access…
      </div>
    );
  }

  if (!resolved) {
    return <Navigate to="/resume-marketing/resume-tracking" replace />;
  }

  return children;
};

export default ResumeMarketingResumeTrackingRoute;
